export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "petname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name of your Pet"])},
        "race": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pet race"])},
        "age": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pet Age"])},
        "petCreate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create new pet"])},
        "createPetForm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter your pet details"])},
        "submitPetBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Submit Pet"])},
        "Pet_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "Pet_age": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Age"])},
        "Pet_Size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])},
        "Pet_breed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Breed"])},
        "Allergies__diseases": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allergies"])},
        "Vaccinations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaccinations"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])}
      },
      "de": {
        "petname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name deines Haustiers"])},
        "race": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rasse"])},
        "age": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alter"])},
        "petCreate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erstelle neues Haustier"])},
        "createPetForm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebe deine Haustierdaten ein"])},
        "submitPetBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haustier einreichen"])},
        "Pet_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "Pet_age": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alter"])},
        "Pet_Size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Größe"])},
        "Pet_breed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rasse"])},
        "Allergies__diseases": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allergien"])},
        "Vaccinations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impfungen"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beschreibung"])}
      }
    }
  })
}